// Item rows are unmounted and remounted as filters change, which destroys and
// recreates their <img> elements. Without a retained reference the browser is
// free to drop the decoded bitmap, so each remount costs another network
// request (blob storage does not send Cache-Control by default) plus a decode
// on the main thread, which competes with in-flight animations.
//
// Holding an Image object per URL keeps the resource in the browser's memory
// cache, so a remount reuses it instead of refetching and re-decoding.

const MAX_RETAINED_IMAGES = 300;

const retainedImages = new Map();

export function isImageRetained(url) {
  return Boolean(url) && retainedImages.has(url);
}

export function retainImage(url) {
  if (!url || typeof window === "undefined") return;
  if (retainedImages.has(url)) return;

  if (retainedImages.size >= MAX_RETAINED_IMAGES) {
    // Map preserves insertion order, so the first key is the oldest entry.
    const oldestUrl = retainedImages.keys().next().value;
    retainedImages.delete(oldestUrl);
  }

  const image = new Image();
  image.decoding = "async";
  image.src = url;
  retainedImages.set(url, image);
}

export function releaseRetainedImages() {
  retainedImages.clear();
}
